import React from "react";
import { Button, Tooltip, List as AntdList } from "antd";
import { withTranslation } from "react-i18next";
import * as R from "ramda";

import Item from "./Item";

import styled from "styled-components/macro";

const RoomItem = styled.li`
  box-shadow: 0 5px 10px gainsboro;
  background: white;
  padding: 10px;
  width: 100%;
  transition: 0.3s ease;

  &:not(:first-child) {
    margin-top: 20px;
  }

  &:hover {
    box-shadow: 0 8px 15px gainsboro;
  }
`;

const List = ({ data, onRemove, t, ...props }) => (
  <AntdList
    itemLayout="horizontal"
    dataSource={data}
    locale={{ emptyText: t("opportunity:process.rooms.empty") }}
    renderItem={room => {
      const isEmpty = R.propSatisfies(
        R.either(R.isEmpty, R.isNil),
        "candidates",
        room
      );

      return (
        <RoomItem>
          <Item
            room={room}
            actions={[
              <Tooltip
                title={
                  isEmpty
                    ? t("opportunity:process.rooms.deleteRoom")
                    : t("opportunity:process.rooms.removeEmpty")
                }
              >
                <Button
                  ghost
                  disabled={!isEmpty}
                  type="danger"
                  icon="delete"
                  onClick={() => onRemove(room.id)}
                />
              </Tooltip>
            ]}
          />
        </RoomItem>
      );
    }}
    {...props}
  />
);

export default withTranslation(["opportunity"])(List);
